import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { GreyLayout } from '@/layouts/GreyLayout';
import { Preloader } from '@/components/Preloader';
import { useApplicationStatusByFundraisingId } from '@/hooks/shared/useApplicationStatusByFundraisingId';
import { FR_APPLICATION_STATUSES } from '@/helpers/fundraising';
import { APP_LINKS } from '@/helpers/links';
import { ReportingStatus } from './ReportingStatus';
import ReportingForm from './form';

const FundraisingApplicationUploadPage = () => {
  const [showMessage, setShowMessage] = useState(false);
  const location = useLocation();
  const hasRequiredState =
    location.state?.fundraisingId !== undefined &&
    location.state?.fundraisingId !== null &&
    location.state?.newFunds !== undefined &&
    location.state?.newFunds !== null &&
    location.state?.newFunds !== '' &&
    Number.isFinite(Number(location.state?.newFunds)) &&
    Array.isArray(location.state?.refinancing);
  const fundraisingId = hasRequiredState ? location.state.fundraisingId : null;
  const { application, isLoading } = useApplicationStatusByFundraisingId(fundraisingId);
  const applicationId = application?.application_id;

  useEffect(() => {
    if (application?.status === FR_APPLICATION_STATUSES.CHANGES_REQUESTED) {
      setShowMessage(true);
    }
  }, [application]);

  if (!hasRequiredState) {
    return <Navigate to={APP_LINKS.fundraising} replace />;
  }

  if (!application || isLoading) {
    return (
      <GreyLayout>
        <Preloader style={{ height: '70vh' }} />
      </GreyLayout>
    );
  }

  return (
    <GreyLayout>
      {[FR_APPLICATION_STATUSES.NEW, FR_APPLICATION_STATUSES.CHANGES_REQUESTED, null].includes(
        application.status,
      ) && !showMessage ? (
        <ReportingForm report={application} applicationId={applicationId} />
      ) : (
        <ReportingStatus
          report={application}
          applicationId={applicationId}
          fundraisingId={fundraisingId}
          setShowMessage={setShowMessage}
        />
      )}
    </GreyLayout>
  );
};

export default FundraisingApplicationUploadPage;
